<div class="mb-3 message-card">
  @if (displayAddMessage) {
    <div>
      <mwp-text-translate text="Enrollment is REQUIRED in a benefit for every category displayed below. You must select a single benefit from each category to continue. Benefits that are pre-selected are required under the terms of this benefit. If you are currently enrolled in any of the benefits listed below, these benefits will remain active. Click confirm to continue." jsonKey="coreBenefitDisplayAddMessage" />
    </div>
  }
  @if (!displayAddMessage) {
    <div>
      <mwp-text-translate text="Please select the plan option you wish to add to your benefits package. If only one option is displayed it will be pre-selected for you. Click Next to continue." jsonKey="coreBenefitDontDisplayAddMessage" />
    </div>
  }
</div>
<div class="content-container table-comp standard-table-fix mb-3">
  @for (coreBenefitCategory of coreBenefitResponse.benefitCategories; track coreBenefitCategory) {
    <div class="title">
      {{coreBenefitCategory.categoryName}}
    </div>
    <div class="content">
      <table>
        <thead>
          <tr>
            <th style="width: 5%;">
            </th>
            <th>
              Benefit
            </th>
          </tr>
        </thead>
        <tbody>
          @for (coreBenefit of coreBenefitCategory.items; track coreBenefit) {
            <tr>
              <td>
                <mat-checkbox [checked]="coreBenefit.isSelected" [disabled]="coreBenefit.isRequired" (change)="selectedCore($event, coreBenefit.uniqueID, coreBenefitCategory.categoryID)"></mat-checkbox>
              </td>
              <td>
                {{coreBenefit.enrollmentName}}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
  <div class="footer">
    <mwp-benefit-enrollment-wizard-control [isContinueDisabled]="!enableConfirmButton" (emitComplete)="submitCoreComplete()"></mwp-benefit-enrollment-wizard-control>
  </div>
</div>
